import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import {
  getInformationList,
  type InformationListParams,
} from '@/services/admin/informations';
import useAppToast from '@/hooks/useAppToast';
import { getApiErrorMessage, DEFAULT_FETCH_ERROR_MESSAGE } from '@/utils/apiError';

export type { InformationListParams, InformationListResponse } from '@/services/admin/informations';

export const useAdminInformationList = (
  site: string | null,
  params: InformationListParams
) => {
  const toast = useAppToast();

  const { data, isLoading, isError, isPending, refetch, error } = useQuery({
    queryKey: ['admin', 'informations', site ?? '', params],
    queryFn: () => getInformationList(site!, params),
    enabled: !!site,
    staleTime: 0,
  });

  useEffect(() => {
    if (isError && error) {
      toast.error(getApiErrorMessage(error, DEFAULT_FETCH_ERROR_MESSAGE));
    }
  }, [isError, error, toast]);

  return { data, isLoading, isError, isPending, refetch, error };
};
